import { Controller } from "@hotwired/stimulus"

// Handles clearing of search/filter input fields
// Usage:
//   .gl-clearable-input{ data: { controller: 'clearable-input' } }
//     = text_field :search, ..., data: { clearable_input_target: 'input', action: 'input->clearable-input#toggleClearButton' }
//     %button.gl-clear-btn{ type: 'button', data: { clearable_input_target: 'clearButton', action: 'clearable-input#clear' } }
//       %i.ph.ph-x-circle
export default class extends Controller {
  static targets = ["input", "clearButton", "searchButton"]

  connect() {
    this.toggleClearButton()

    // Clear input before Turbo caches the page so it doesn't persist when navigating back
    this.handleTurboBeforeCache = () => {
      if (this.hasInputTarget) {
        this.inputTarget.value = ""
        this.toggleClearButton()
      }
    }
    document.addEventListener("turbo:before-cache", this.handleTurboBeforeCache)
  }

  disconnect() {
    if (this.handleTurboBeforeCache) {
      document.removeEventListener("turbo:before-cache", this.handleTurboBeforeCache)
      this.handleTurboBeforeCache = null
    }
  }

  clear(event) {
    event.preventDefault()

    if (this.hasInputTarget) {
      this.inputTarget.value = ""
      this.toggleClearButton()

      // Dispatch input event to trigger any existing filter handlers
      this.inputTarget.dispatchEvent(new Event("input", { bubbles: true }))

      // Navigate directly to form action URL to avoid ?search_filter= appearing in URL
      const form = this.inputTarget.closest("form")
      if (form) {
        if (typeof Turbo !== 'undefined') {
          Turbo.visit(form.action)
        } else {
          console.warn('[clearable_input_controller] Turbo unavailable, using fallback navigation')
          window.location.href = form.action
        }
      }
    }
  }

  toggleClearButton() {
    if (!this.hasInputTarget) return

    const hasValue = this.inputTarget.value.trim().length > 0
    if (this.hasClearButtonTarget) {
      this.clearButtonTarget.classList.toggle("d-none", !hasValue)
    }
    if (this.hasSearchButtonTarget) {
      this.searchButtonTarget.classList.toggle("d-none", !hasValue)
    }
  }
}
